import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import mapHome from '@/components/mapdemo/mapHome'
import mapGaode from '@/components/mapdemo/mapGaode'
import mapGoogle from '@/components/mapdemo/mapGoogle'
import mapTencent from '@/components/mapdemo/mapTencent'
import mapOpenStreet from '@/components/mapdemo/mapOpenStreet'
import mapUseView from '@/components/mapdemo/mapUseView'
import mapUseTangram from '@/components/mapdemo/mapUseTangram'
import mapUseOpenlayer from '@/components/mapdemo/mapUseOpenlayer'
import mapOsmbuildings from '@/components/mapdemo/mapOsmbuildings'
import iView from 'iview'
import 'iview/dist/styles/iview.css' // 使用 CSS

Vue.use(Router)
Vue.use(iView)

export default new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/mapview',
      name: 'mapHome',
      component: mapHome
    },
    {
      path: '/mapview/openstreet',
      name: 'mapOpenStreet',
      component: mapOpenStreet
    },
    {
      path: '/mapview/amap',
      name: 'mapGaode',
      component: mapGaode
    },
    {
      path: '/mapview/google',
      name: 'mapGoogle',
      component: mapGoogle
    },
    {
      path: '/mapview/tencent',
      name: 'mapTencent',
      component: mapTencent
    },
    {
      path: '/mapview/map',
      name: 'mapUseView',
      component: mapUseView
    },
    {
      path: '/mapview/tangram',
      name: 'mapUseTangram',
      component: mapUseTangram
    },
    {
      path: '/mapview/openlayer',
      name: 'mapUseOpenlayer',
      component: mapUseOpenlayer
    },
    {
      path: '/mapview/mapOsmbuildings',
      name: 'mapOsmbuildings',
      component: mapOsmbuildings
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js